import React, {useEffect, useState} from "react";
import PropertyPage from "../index";
import {Form, Input, Select} from "antd";
import UploadFileContent from "../../../components/UploadFileContent";
import PropertyService from "../../../services/property.service";


const {Option} = Select;
export default function PlacePage(props: any) {
    const [countries, setCountries]: any = useState([]);
    const [cities, setCities]: any = useState([]);

    useEffect(() => {
        PropertyService.list('country').then(value => {
            if (value) {
                const v = value.map((x: any) => {
                    return {
                        name: x.value.name,
                        _id: x._id
                    }
                });
                setCountries(v);
            }
        });
        PropertyService.list('city').then(value => {
            if (value) {
                const v = value.map((x: any) => {
                    return {
                        name: x.value.name,
                        _id: x._id
                    }
                });
                setCities(v);
            }
        })
    }, [])

    const columns = [
        {
            title: 'Hình ảnh',
            dataIndex: 'image',
            key: 'image',
            render: (value: any, item: any, index: number) => <img style={{width: 50, height: 'auto'}}
                                                                   src={item.value.image}/>,
        },
        {
            title: 'Tên địa điểm',
            dataIndex: ['value', 'name'],
            key: 'value',
        }, {
            title: 'Tỉnh thành',
            dataIndex: ['value', 'cityId'],
            key: 'value',
            render: (cell: any, row: any) => (cities.find((x: any) => x._id === cell)?.name || "")
        },
        {
            title: 'Quốc gia',
            dataIndex: ['value', 'countryId'],
            key: 'value',
            render: (cell: any, row: any) => (countries.find((x: any) => x._id === cell)?.name || "")
        },
    ];

    return (
        <>
            <PropertyPage title='Quản lý địa điểm đến' desc="Khách sạn" type='place' columns={columns}>
                <Form.Item name={['countryId']} label="Quốc gia">
                    <Select>
                        {
                            countries.map((value: any, index: number) => {
                                return (
                                    <Option key={index.toString()} value={value._id}>{value.name}</Option>
                                )
                            })
                        }
                    </Select>
                </Form.Item>
                <Form.Item name={['cityId']} label="Tỉnh thành">
                    <Select>
                        {
                            cities.map((value: any, index: number) => {
                                return (
                                    <Option key={index.toString()} value={value._id}>{value.name}</Option>
                                )
                            })
                        }
                    </Select>
                </Form.Item>
                <Form.Item name={['name']} label="Tên địa điểm">
                    <Input placeholder="Nhập tên địa điểm"/>
                </Form.Item>
                <Form.Item label="Chọn icon">
                    <Form.Item name="image">
                        <UploadFileContent/>
                    </Form.Item>
                </Form.Item>
            </PropertyPage>
        </>
    )
}
